if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  if (window.location.pathname.includes("/products")) {
    setTimeout(() => {
      const targetProduct = document.querySelector("#product-form-installment");
      if (targetProduct) {
        const mutationObserver = new MutationObserver((recordList, observe) => {
          const productForm = document.querySelector(
            '[bss-b2b-product-form="main"]'
          );
          BSS_B2B.observer.productSubject.notifyObserver(
            "VariantChange",
            "VariantSelectChange",
            { productForm }
          );
        });
        mutationObserver.observe(targetProduct, {
          childList: true,
          subtree: true,
        });
      }
    }, 3000);
  }

  function handleNT() {
    const targetElement = document.querySelector(".bss-checkout");
    if (
      targetElement.parentNode.querySelector("#bss-b2b-net-term-button-wrapper")
    )
      return;
    targetElement.insertAdjacentHTML(
      "afterEnd",
      `<div id="bss-b2b-net-term-button-wrapper">
          <button type="button" id="bss-b2b-net-term-button">Pay later</button>
      </div>`
    );

    BSS_B2B.nt.initFunction();
    document.dispatchEvent(new Event("DOMContentLoaded"));

    function copyStyles(source, target) {
      const computed = window.getComputedStyle(source);
      for (let i = 0; i < computed.length; i++) {
        const prop = computed[i];
        const value = computed.getPropertyValue(prop);
        target.style.setProperty(
          prop,
          value,
          computed.getPropertyPriority(prop)
        );
      }

      const pseudoList = ["::before", "::after"];

      pseudoList.forEach((pseudo) => {
        const pseudoStyles = window.getComputedStyle(source, pseudo);
        const content = pseudoStyles.getPropertyValue("content");

        if (content && content !== "none") {
          const css = Array.from(pseudoStyles)
            .map((prop) => `${prop}: ${pseudoStyles.getPropertyValue(prop)};`)
            .join(" ");

          const style = document.createElement("style");
          style.textContent = `
              #${target.id}${pseudo} {
                ${css}
              }
            `;
          document.head.appendChild(style);
        }
      });
    }

    const source = document.querySelector(".bss-checkout");
    const target = document.querySelector("#bss-b2b-net-term-button");

    copyStyles(source, target);
  }

  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      // console.log(MutationList)
      for (let item of MutationList) {
        if (item.target.id === "mu-checkout-container") {
          updateCartPrices();
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 300);

  function updateCartPrices() {
    if (
      !BSS_B2B?.storage?.cartStorage?.store ||
      BSS_B2B.storage.cartStorage.store.size === 0
    ) {
      console.warn("Cart storage is empty or unavailable.");
      return;
    }

    const cartMap = new Map();
    BSS_B2B.storage.cartStorage.store.forEach((value) => {
      cartMap.set(String(value.variant_id), value.key);
    });

    document.querySelectorAll(".mu-cart-item").forEach((item) => {
      const variantId = item.getAttribute("data-variant-id");
      const priceElement = item.querySelector(".mu-item-price");

      if (variantId && priceElement) {
        const cartKey = cartMap.get(String(variantId));

        if (cartKey) {
          if (!priceElement.hasAttribute("bss-b2b-cart-item-key")) {
            priceElement.setAttribute("bss-b2b-cart-item-key", cartKey);
          }
          if (!priceElement.hasAttribute("bss-b2b-item-original-price")) {
            priceElement.setAttribute("bss-b2b-item-original-price", "");
          }
        }
      }
    });

    const subtotalElement = document.querySelector(".mu-checkout-btn .money");
    if (
      subtotalElement &&
      !subtotalElement.hasAttribute("bss-b2b-cart-total-price")
    ) {
      subtotalElement.setAttribute("bss-b2b-cart-total-price", "");
    }
    BSS_B2B.observer.cartSubject.notifyObserver(
      "CartMutate",
      "CartPriceMutate"
    );
  }

  setTimeout(() => {
    let quickViewBtn = document.querySelectorAll("quick-view-product");
    if (quickViewBtn.length) {
      for (let i = 0; i < quickViewBtn.length; i++) {
        quickViewBtn[i].onclick = function () {
          setTimeout(async function () {
            const productId = quickViewBtn[i]
              .querySelector("a")
              .getAttribute("data-id");
            const productForm = document.querySelector(
              `product-page[data-id="${productId}"]`
            );
            if (!productForm.getAttribute("bss-b2b-product-form-id")) {
              document.dispatchEvent(new Event("bss_b2b:QuickviewLoaded"));
            }
            const targetProduct = productForm.querySelectorAll(
              ".product-variant__container .product-variant__item"
            );
            if (targetProduct.length) {
              targetProduct.forEach((item) => {
                item.addEventListener("click", () => {
                  setTimeout(() => {
                    BSS_B2B.observer.productSubject.notifyObserver(
                      "VariantChange",
                      "VariantSelectChange",
                      { productForm }
                    );
                  }, 500);
                });
              });
            }
          }, 2000);
        };
      }
    }
  }, 3000);
}